import { isAfter, isValid, parseISO } from 'date-fns';
import moment from 'moment-business-days';

const formCurrency = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 3,
});
const formCurrency3 = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 3,
  maximumFractionDigits: 3,
});

interface ValidGtinResult {
  valid: boolean;
  message: string;
}

export function validaGtin(gtin: string, tipo: number): ValidGtinResult {
  const gtinSemDigito = gtin.substring(0, gtin.length - 1);
  let digito = '';

  switch (tipo) {
    case 8:
    case 12:
    case 14:
      digito = digitoGtinX3(gtinSemDigito);
      break;
    default:
      digito = digitoGtinX1(gtinSemDigito);
      break;
  }

  if (gtin.substring(gtin.length - 1, gtin.length) !== digito) {
    return {
      valid: false,
      message: 'GTIN inválido: O dígito verificador não confere.',
    };
  }
  return { valid: true, message: 'GTIN Valido' };
}

export function geraDigitoPLU(plu: string): string {
  return formatPLU(plu + digitoGtinX3(plu));
}

function digitoGtinX3(gtin: string) {
  let sum = 0;
  gtin = String(gtin);
  gtin.split('').map((num, pos) => {
    if (pos % 2 === 0) {
      sum += Number(num) * 3;
      return Number(num) * 3;
    }
    sum += Number(num);
    return Number(num);
  });

  const digito = 10 * (Math.trunc(sum / 10) + 1) - sum;
  if (digito === 10) {
    return '0';
  }
  return String(digito);
}

function digitoGtinX1(gtin: string) {
  let sum = 0;
  gtin.split('').map((num, pos) => {
    if (pos % 2 === 0) {
      sum += Number(num);
      return Number(num);
    }
    sum += Number(num) * 3;
    return Number(num) * 3;
  });

  const digito = 10 * (Math.trunc(sum / 10) + 1) - sum;
  if (digito === 10) {
    return '0';
  }
  return String(digito);
}

export function formatPLU(plu: string): string {
  return plu.padStart(8, '0');
}

export function fltRound(numero: any, dp: number): any {
  if (arguments.length !== 2) throw new Error('2 arguments required');

  const num = String(numero);
  if (num.indexOf('e+') !== -1) {
    // Can't round numbers this large because their string representation
    // contains an exponent, like 9.99e+37
    throw new Error('num too large');
  }
  if (num.indexOf('.') === -1) {
    // Nothing to do
    return num;
  }

  const parts = num.split('.');
  const beforePoint = parts[0];
  let afterPoint = parts[1];
  const shouldRoundUp = parseFloat(afterPoint[dp]) >= 5;
  let finalNumber;

  afterPoint = afterPoint.slice(0, dp);
  if (!shouldRoundUp) {
    finalNumber = `${beforePoint}.${afterPoint}`;
  } else if (/^9+$/.test(afterPoint)) {
    // If we need to round up a number like 1.9999, increment the integer
    // before the decimal point and discard the fractional part.
    finalNumber = (Number(beforePoint) + 1).toString();
  } else {
    // Starting from the last digit, increment digits until we find one
    // that is not 9, then stop
    let i = dp - 1;
    while (true) {
      if (afterPoint[i] === '9') {
        afterPoint = `${afterPoint.substr(0, i)}0${afterPoint.substr(i + 1)}`;
        i--;
      } else {
        afterPoint =
          afterPoint.substr(0, i) +
          (Number(afterPoint[i]) + 1) +
          afterPoint.substr(i + 1);
        break;
      }
    }

    finalNumber = `${beforePoint}.${afterPoint}`;
  }

  // Remove trailing zeroes from fractional part before returning
  return parseFloat(finalNumber.replace(/0+$/, ''));
}

export function transformAsCurrency(value: string | number | null): number {
  if (value === null) return 0;
  if (typeof value === 'number') return value;
  if (value === '') return 0;
  if (value.length < 6) {
    value = value.replaceAll(',', '.');
  } else {
    value = value.replaceAll('.', '').replace(',', '.');
  }
  return Number(value);
}

export const roundByRule = (valor: number, tolerancia = 0.01): number => {
  const arredondado = Math.round(valor);
  const diferenca = parseFloat((valor - arredondado).toFixed(10));

  if (Math.abs(diferenca) < tolerancia) {
    return arredondado;
  }

  return valor;
};

export function numberToText(value: number | string): string {
  // console.log('value', value, (value.toString().match(/./g) || []).length);
  // if (value.toString().match(/./g) || []).length
  // const splitLength = value.toString().split('.').length;
  // if (splitLength === 1) {
  //   return formatCurrencyAsTex3(Number(value));
  // }
  // console.log('value', value, value.toString().split('.').length);
  // value = value.toString().replaceAll('.', ',');

  // console.log(formatCurrencyAsTex3(Number(value)));
  // return value;
  return formatCurrencyAsTex3(Number(value));
}

export const formatCurrencyAsText = (
  value: number | string | undefined,
  minimumFractionDigits = 2,
  maximumFractionDigits = 3,
): string => {
  if (typeof value === 'string') return value;
  if (value === 0) return '0,00';
  if (value) {
    const formtCurrency = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits,
      maximumFractionDigits,
    });
    const newValue = formtCurrency.format(value);
    if (newValue === 'NaN') return '0,00';
    return newValue;
  }
  return '';
};
export const formatCurrencyAsTex3 = (value: number | undefined): string => {
  if (value) return formCurrency3.format(value);
  return '0';
};

export function getDataUtil(
  ini: string | undefined = undefined,
  dias = 0,
  fim: string | undefined = undefined,
): string {
  moment.updateLocale('us', {
    workingWeekdays: [1, 2, 3, 4, 5],
  });
  const dta_inicial = ini || moment().format('YYYY-MM-DD');
  const dataUtil = moment(dta_inicial, 'YYYY-MM-DD').businessAdd(dias);
  return moment(dataUtil).format('YYYY-MM-DD');
}

export function getDiaUtil(dta: string | undefined = undefined): number {
  const ini = moment().format('YYYY-MM-DD');
  const diff = moment(ini, 'YYYY-MM-DD').businessDiff(
    moment(dta, 'YYYY-MM-DD'),
  );
  return diff;
}

export function validaCPF(value: string): boolean {
  const cpf = value.replace(/[^\d]+/g, '');
  if (cpf === '') return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  )
    return false;
  // // Valida 1o digito
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i), 10) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(9), 10)) return false;
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i), 10) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(10), 10)) return false;
  return true;
}

export function validarCNPJ(cnpj: string): boolean {
  cnpj = cnpj.replace(/\D/g, '');

  if (cnpj.length !== 14) {
    return false;
  }

  if (/^(\d)\1+$/.test(cnpj)) {
    return false;
  }

  function apenasDigitos(str: any) {
    return /^\d+$/.test(str);
  }

  if (!apenasDigitos(cnpj)) {
    return false;
  }

  let soma = 0;
  let peso = 2;
  for (let i = 11; i >= 0; i--) {
    soma += parseInt(cnpj.charAt(i), 10) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const digitoVerificador1 = soma % 11 < 2 ? 0 : 11 - (soma % 11);

  if (parseInt(cnpj.charAt(12), 10) !== digitoVerificador1) {
    return false;
  }

  soma = 0;
  peso = 2;
  for (let i = 12; i >= 0; i--) {
    soma += parseInt(cnpj.charAt(i), 10) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const digitoVerificador2 = soma % 11 < 2 ? 0 : 11 - (soma % 11);

  if (parseInt(cnpj.charAt(13), 10) !== digitoVerificador2) {
    return false;
  }

  return true;
}

export function validaEmail(email: string) {
  if (email === null || email === undefined || email === '') return false;
  email = email.toLowerCase();
  const reg = /^[\w.+]+@\w+.\w{2,}(?:.\w{2})?$/;
  return reg.test(email);
}

export function formatDate(data: string): string {
  const splitedDate = data.split(' ');
  const time = splitedDate[1];
  const date = splitedDate[0];

  // reverse date to format
  let newDate: any = date.split('/');
  newDate = newDate.reverse();
  newDate = newDate.join('-');
  newDate = `${newDate} ${time}`;
  return newDate;
}

export function moneyFormat(
  value: string,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
): string {
  /**
   * Converter o value em String pode parecer redundante uma vez que ele é uma prop do tipo string,
   * porém pode ser que passem uma valor any para ele, o que resultará em erro e quebrará a aplicação.
   * Sendo assim, não retirar o parser do código abaixo.
   */
  return parseFloat(value).toLocaleString('pt-br', {
    minimumFractionDigits,
    maximumFractionDigits,
  });
}

export const validarChaveNFe = (chaveNfe: string): boolean => {
  const peso: number[] = [
    4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4,
    3, 2, 9, 8, 7, 6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2, 0,
  ];
  let retorno = false;

  if (chaveNfe.length !== 44) retorno = false;

  const aChave: string[] = chaveNfe.replace(/\s/g, '').split('');
  let soma = 0;

  for (let i = 0; i < aChave.length; i++) {
    soma += parseInt(aChave[i], 10) * peso[i];
  }

  if (soma === 0) retorno = false;

  soma -= 11 * Math.floor(soma / 11);
  const verif: number = soma === 0 || soma === 1 ? 0 : 11 - soma;

  retorno = verif === parseInt(aChave[43], 10);

  return retorno;
};

export const strPadZeroL = (
  valueOrLen: string | number | null | undefined,
  lenOrValue: string | number | null | undefined,
): string => {
  const len =
    typeof valueOrLen === 'number' ? valueOrLen : Number(lenOrValue ?? 0);
  const value = typeof valueOrLen === 'number' ? lenOrValue : valueOrLen;
  const normalizedValue = String(value ?? '').trim();
  const prefixMatch = normalizedValue.match(/^([A-Za-z]{2})(\d+)$/);

  if (normalizedValue === '') return '';
  if (prefixMatch) {
    const [, prefix, numericPart] = prefixMatch;
    const numericLen = Math.max(len - prefix.length, numericPart.length);
    return `${prefix}${numericPart.padStart(numericLen, '0')}`;
  }
  if (normalizedValue.length >= len) return normalizedValue;

  return normalizedValue.padStart(len, '0');
};

export const delZeroLeft = (s: string): string => {
  let result = s;

  while (result.charAt(0) === '0') {
    result = result.slice(1);
  }

  return result;
};

export const validaIntegridadeDataInicioFim = (
  inicio: string | undefined,
  fim: string | undefined,
): boolean => {
  if (typeof inicio === 'undefined' || typeof fim === 'undefined') return true;

  const dataInicio = parseISO(inicio);
  const dataFim = parseISO(fim);

  if (!isValid(dataInicio) || !isValid(dataFim)) return true;

  if (isAfter(dataInicio, dataFim)) return true;

  return false;
};

export const pontuaCpfCnpj = (value: string): string => {
  const numeros = value.replace(/\D/g, '');

  if (numeros.length === 11)
    return `${numeros.slice(0, 3)}.${numeros.slice(3, 6)}.${numeros.slice(
      6,
      9,
    )}-${numeros.slice(9)}`;

  if (numeros.length === 14)
    return `${numeros.slice(0, 2)}.${numeros.slice(2, 5)}.${numeros.slice(
      5,
      8,
    )}/${numeros.slice(8, 12)}-${numeros.slice(12)}`;

  return '';
};

export const toNumber = (value: unknown): number => {
  if (value === null || value === undefined) return NaN;
  if (typeof value === 'number') return value;
  if (typeof value === 'boolean') return value ? 1 : 0;
  if (typeof value === 'bigint') {
    try {
      return Number(value);
    } catch {
      return NaN;
    }
  }
  if (value instanceof Date) return value.getTime();

  const raw = (value as any)?.valueOf?.() ?? value;
  let str = String(raw).trim();
  if (!str) return NaN;

  str = str
    .replace(/[\u00A0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  let isNegative = false;
  const paren = /^\((.*)\)$/.exec(str);
  if (paren) {
    isNegative = true;
    str = paren[1].trim();
  }
  if (/^[\u2212-]/.test(str)) {
    isNegative = true;
    str = str.replace(/^[\u2212-]/, '');
  }

  str = str.replace(/[^\d.,eE+-]/g, '');
  if (!str) return NaN;

  const hasComma = str.includes(',');
  const hasDot = str.includes('.');

  let normalized = str;

  if (hasComma && hasDot) {
    const lastSep = Math.max(str.lastIndexOf(','), str.lastIndexOf('.'));
    const intPart = str.slice(0, lastSep).replace(/[.,]/g, '');
    const fracPart = str.slice(lastSep + 1).replace(/[^\d]/g, '');
    normalized = `${intPart}.${fracPart}`;
  } else if (hasComma && !hasDot) {
    normalized = str.replace(/\./g, '').replace(',', '.');
  } else if (!hasComma && hasDot) {
    if (/^\d{1,3}(?:\.\d{3})+(?:[eE][+-]?\d+)?$/.test(str)) {
      normalized = str.replace(/\./g, '');
    } else {
      const dots = (str.match(/\./g) || []).length;
      if (dots > 1) {
        const last = str.lastIndexOf('.');
        normalized = `${str.slice(0, last).replace(/\./g, '')}.${str.slice(
          last + 1,
        )}`;
      } else {
        normalized = str;
      }
    }
  } else {
    normalized = str;
  }

  normalized = normalized.replace(/,/g, '');

  const n = Number(normalized);
  return isNegative ? -n : n;
};

export const toNumberOrZero = (v: unknown): number => {
  const n = toNumber(v);
  return Number.isNaN(n) ? 0 : n;
};

/**
 * Extrai apenas dígitos de um input qualquer, preservando sinal negativo inicial.
 */
const extractDigits = (
  value: unknown,
): { isNegative: boolean; digits: string } => {
  const raw = String(value ?? '').trim();

  // considera negativo apenas se o primeiro caracter for '-'
  const isNegative = raw.startsWith('-');
  const digits = raw.replace(/\D/g, ''); // remove tudo que não é [0-9]

  return { isNegative, digits };
};

/**
 * Converte um input qualquer para centavos (inteiro).
 * Exemplos:
 *  "0,01" -> 1   |  "12,34" -> 1234  |  "1.234,56" -> 123456
 *  "12.34" -> 1234 (aceita ponto)     |  "" -> 0 (ou null se allowEmpty)
 */
export const toCents = (input: unknown, allowEmpty = false): number | null => {
  const { isNegative, digits } = extractDigits(input);
  if (!digits) return allowEmpty ? null : 0;

  // número inteiro representando centavos: "12,34" vira "1234"
  const cents = Number.parseInt(digits, 10);
  return isNegative && cents !== 0 ? -cents : cents;
};

/**
 * Formata centavos em string pt-BR com 2 casas. Pode incluir símbolo "R$".
 * Exemplos:
 *  1 -> "0,01"        |  1234 -> "12,34"     |  123456 -> "1.234,56"
 *  -1234 -> "-12,34"  |  withSymbol: true -> "R$ 12,34"
 */
export const formatCents = (
  cents: number | null | undefined,
  withSymbol = false,
): string => {
  if (cents == null) return '';
  const negative = cents < 0;
  const abs = Math.abs(cents) / 100;

  const formatter = new Intl.NumberFormat('pt-BR', {
    ...(withSymbol ? { style: 'currency', currency: 'BRL' } : {}),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatted = formatter.format(abs);
  return negative ? `-${formatted}` : formatted;
};

/**
 * Entrada "qualquer coisa" -> Saída formatada "pt-BR" com 2 casas.
 * Usa a estratégia: normaliza para centavos -> formata.
 */
export const formatCurrencyBR = (
  input: unknown,
  { allowEmpty = false, withSymbol = false }: any = {},
): string => {
  const cents = toCents(input, allowEmpty);
  // se allowEmpty e não há dígitos, devolve vazio; caso contrário, "0,00"
  if (cents === null) return '';
  return formatCents(cents, withSymbol);
};

/**
 * Normaliza e formata um CEP brasileiro no padrão "#####-###".
 *
 * Regras:
 * - Remove tudo que não for dígito.
 * - Se houver MAIS de 8 dígitos, usa os 8 primeiros (comportamento padrão).
 * - Se houver MENOS de 8 dígitos, retorna null (a menos que acceptPartial=true).
 *
 * Opções:
 * - strict: exige exatamente 8 dígitos após a limpeza; caso contrário retorna null.
 * - acceptPartial: permite retorno parcial mascarado quando < 8 dígitos (ex.: "12345-6").
 *
 * Exemplos:
 * formatCep("44.059-784")              -> "44059-784"
 * formatCep(" CEP: 44059 784 ")        -> "44059-784"
 * formatCep("44059784")                -> "44059-784"
 * formatCep("99-999-9999")             -> "99999-999"   // pega os 8 primeiros
 * formatCep("44059", { acceptPartial: true }) -> "44059"
 * formatCep("440596", { acceptPartial: true }) -> "44059-6"
 * formatCep("44059-784-99", { strict: true }) -> null
 */
export type FormatCepOptions = {
  strict?: boolean;
  acceptPartial?: boolean;
};

export const formatCep = (
  value: unknown,
  options: FormatCepOptions = {},
): string | null => {
  const { strict = false, acceptPartial = false } = options;

  if (value == null) return null;

  // Extrai somente dígitos
  const digits = String(value).replace(/\D+/g, '');
  if (digits.length === 0) return null;

  if (strict && digits.length !== 8) return null;

  // Garante até 8 dígitos
  const upToEight = digits.slice(0, Math.min(8, digits.length));

  // Se não aceitar parcial e tiver menos de 8, considere inválido
  if (!acceptPartial && upToEight.length < 8) return null;

  // Monta a máscara:
  // - Parcial: insere hífen somente quando houver >5 dígitos
  // - Completo: sempre "#####-###"
  if (acceptPartial) {
    if (upToEight.length <= 5) return upToEight;
    return `${upToEight.slice(0, 5)}-${upToEight.slice(5)}`;
  }

  return `${upToEight.slice(0, 5)}-${upToEight.slice(5)}`;
};

export type PhoneMode = 'auto' | 'mobile' | 'landline';

export type FormatPhoneOptions = {
  /**
   * 'auto' (padrão): tenta detectar pelo total de dígitos (11 = celular, 10 = fixo).
   * 'mobile': força formato de celular (11 dígitos).
   * 'landline': força formato de telefone fixo (10 dígitos).
   */
  mode?: PhoneMode;
  /**
   * Se true, exige a quantidade exata de dígitos do modo escolhido.
   * Caso não atinja, retorna null. Padrão: false.
   */
  strict?: boolean;
  /**
   * Se true, permite máscara parcial (útil para onChange).
   * Padrão: false (retorna null quando incompleto).
   */
  acceptPartial?: boolean;
  /**
   * Se true, mantém o prefixo +55 no retorno quando possível. Padrão: false.
   */
  keepCountry?: boolean;
};

/**
 * Normaliza e formata telefone/celular brasileiro.
 * Exemplos:
 * - formatBrPhone("(71) 2766-1412")              -> "(71) 2766-1412"
 * - formatBrPhone(" +55 (71) 98609-0706 ")       -> "(71) 98609-0706"
 * - formatBrPhone("0 15 71 986090706")           -> "(71) 98609-0706"
 * - formatBrPhone("71986090706")                 -> "(71) 98609-0706"
 * - formatBrPhone("71 27661412", { mode:'mobile', strict:true }) -> null
 * - formatBrPhone("71 2766", { acceptPartial:true })            -> "(71) 2766"
 */
export const formatBrPhone = (
  value: unknown,
  options: FormatPhoneOptions = {},
): string | null => {
  const {
    mode = 'auto',
    strict = false,
    acceptPartial = false,
    keepCountry = false,
  } = options;

  if (value == null) return null;

  // 1) Extrai somente dígitos
  let digits = String(value).replace(/\D+/g, '');
  if (!digits) return null;

  // 2) Remove país (55) e prefixos de longa distância (0 + código da operadora, ex.: 015)
  digits = stripCountryAndCarrier(digits);

  // 3) Escolhe alvo de tamanho conforme o modo
  const targetLen =
    mode === 'mobile' ? 11 : mode === 'landline' ? 10 : undefined;

  // 4) Recorte preferindo dígitos à direita (sobram prefixos à esquerda)
  const preferred = (len: number) =>
    digits.length >= len ? digits.slice(-len) : digits;

  let core = digits;

  if (mode === 'mobile') {
    core = preferred(11);
  } else if (mode === 'landline') {
    core = preferred(10);
  } else {
    // auto: se tiver 11, assume celular; se 10, assume fixo; senão mantém para parcial/validação
    if (digits.length >= 11) core = preferred(11);
    if (digits.length >= 10) core = preferred(10);
  }

  // 5) Regras de estrito/parcial
  if (strict) {
    if (mode === 'mobile' && core.length !== 11) return null;
    if (mode === 'landline' && core.length !== 10) return null;
    if (mode === 'auto' && !(core.length === 10 || core.length === 11))
      return null;
  } else if (!acceptPartial) {
    // Não estrito e sem parcial: exige completo do tipo detectado
    const fullOk =
      (mode === 'mobile' && core.length === 11) ||
      (mode === 'landline' && core.length === 10) ||
      (mode === 'auto' && (core.length === 10 || core.length === 11));

    if (!fullOk) return null;
  }

  // 6) Formatação (com parcial se habilitado)
  const withCountry = (formatted: string) =>
    keepCountry ? `+55 ${formatted}` : formatted;

  // Suporte simples a 0800 (mantém padrão "0800 123 4567")
  if (core.startsWith('0800')) {
    const s = format0800(core, acceptPartial);
    return s ? (keepCountry ? `+55 ${s}` : s) : null;
  }

  if (core.length <= 2) {
    // Apenas DDD parcial
    return withCountry(`(${core}`);
  }

  if (
    core.length === 10 ||
    (acceptPartial && core.length < 11 && core.length > 2 && mode !== 'mobile')
  ) {
    // Fixo ou parcial plausível de fixo
    return withCountry(maskPhone(core, [2, 4, 4], acceptPartial) ?? '');
  }

  // Celular (11) ou parcial plausível de celular
  return withCountry(maskPhone(core, [2, 5, 4], acceptPartial) ?? '');
};

// ----------------- Helpers -----------------

/**
 * Remove +55/55 no início e opcionalmente "0" + código de operadora (dois dígitos).
 * Ex.: 0 15 11 9... -> remove "0 15".
 */
const stripCountryAndCarrier = (rawDigits: string): string => {
  let d = rawDigits;

  // remove país
  if (d.startsWith('55')) d = d.slice(2);

  // remove "0" + código de operadora (2 dígitos) se ainda houver sobra suficiente
  if (d.startsWith('0') && d.length >= 13) {
    d = d.slice(1); // remove '0'
    if (d.length >= 12) d = d.slice(2); // remove código (ex.: 15, 21, 41...)
  }

  return d;
};

/**
 * Aplica máscara com DDD (2) + segmentos posteriores.
 * seg = [2,4,4] para fixo ou [2,5,4] para celular (o primeiro 2 é o DDD).
 */
const maskPhone = (
  digits: string,
  seg: [2, number, number],
  partial: boolean,
): string | null => {
  const total = seg[0] + seg[1] + seg[2];
  const d = digits.slice(0, Math.min(total, digits.length));

  const ddd = d.slice(0, 2);
  const rest = d.slice(2);

  if (!partial && d.length < total) return null;

  if (!rest) return `(${ddd}`;

  // Monta sequência restante com hífen entre os dois últimos blocos
  const firstBlockLen = seg[1];
  const secondBlockLen = seg[2];

  if (rest.length <= firstBlockLen) {
    return `(${ddd}) ${rest}`;
  }

  const firstBlock = rest.slice(0, firstBlockLen);
  const secondBlock = rest.slice(firstBlockLen, firstBlockLen + secondBlockLen);

  if (partial && rest.length < firstBlockLen + secondBlockLen) {
    // Ainda não alcançou o último bloco completo
    return `(${ddd}) ${firstBlock}${secondBlock ? `-${secondBlock}` : ''}`;
  }

  return `(${ddd}) ${firstBlock}-${secondBlock}`;
};

/** Formata 0800 (11 dígitos) com parcial opcional. */
const format0800 = (digits: string, partial: boolean): string | null => {
  const d = digits.slice(0, Math.min(11, digits.length)); // 0800 + 7 dígitos
  if (!d.startsWith('0800')) return null;
  const rest = d.slice(4); // 7 dígitos

  if (!partial && d.length < 11) return null;

  if (rest.length <= 3) return `0800 ${rest}`;
  if (rest.length <= 7) return `0800 ${rest.slice(0, 3)} ${rest.slice(3)}`;
  return `0800 ${rest.slice(0, 3)} ${rest.slice(3, 7)}`;
};

// ----------------- Validadores convenientes -----------------

/** Retorna true se o número (após normalização) for celular (11 dígitos). */
export const isValidBrMobile = (value: unknown): boolean => {
  const d = stripCountryAndCarrier(String(value ?? '').replace(/\D+/g, ''));
  return d.length >= 11 && d.slice(-11).length === 11;
};

/** Retorna true se o número (após normalização) for fixo (10 dígitos). */
export const isValidBrLandline = (value: unknown): boolean => {
  const d = stripCountryAndCarrier(String(value ?? '').replace(/\D+/g, ''));
  return d.length >= 10 && d.slice(-10).length === 10;
};
